export function commodityGroupToSelect(commodityGroups) {
    let cleanedCommodityGroups = [];
    commodityGroups.map((item) => (
        cleanedCommodityGroups.push({
            label: item.name,
            value: item.id,
            item: item,
        })
    ));
    return cleanedCommodityGroups;
}


// WEBPACK FOOTER //
// ./src/utils/commodityGroup.js